import { render, staticRenderFns } from "./customer_private_seas.vue?vue&type=template&id=58c4cb06&scoped=true&"
import script from "./customer_private_seas.vue?vue&type=script&lang=js&"
export * from "./customer_private_seas.vue?vue&type=script&lang=js&"
import style0 from "./customer_private_seas.vue?vue&type=style&index=0&id=58c4cb06&prod&lang=scss&scoped=true&"
import style1 from "./customer_private_seas.vue?vue&type=style&index=1&id=58c4cb06&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c4cb06",
  null
  
)

export default component.exports